export const EMPTY_VALUE: any = {}
